import './map-container.css';

function MapContainer({ position = 'top-left', children, className = '' }) {
  return (
    <div className={`map-container map-container--${position} ${className}`.trim()}>
      {children}
    </div>
  );
}

export default MapContainer;
